export interface BotCoefficients {
  create_project?: number;
  create_ahu: number;
  update_ahu: number;
  update_tunnel: number;
  size: number;
  fan_rate: number;
  fan_create: number;
  compile_errors: number;
  coil_rate: number;
  coil_create: number;
  filter_rate: number;
  filter_create: number;
  create_section: number;
  update_section: number;
  drain_pan: number;
  access_door: number;
  opening: number;
  update_tunnel_floor_casing: number;
  increase_tunnel_length: number;
  increase_tunnel_width: number;
  er_wheel_rate: number;
  er_wheel_create: number;
}

export const DEFAULT_COEFFICIENTS: BotCoefficients = {
  create_project: 2,
  create_ahu: 2,
  update_ahu: 2,
  update_tunnel: 2,
  size: 2,
  fan_rate: 9,
  fan_create: 5,
  compile_errors: 3,
  coil_rate: 5,
  coil_create: 5,
  filter_rate: 5,
  filter_create: 2,
  er_wheel_rate: 5,
  er_wheel_create: 5,
  create_section: 2,
  update_section: 1,
  drain_pan: 2,
  access_door: 3,
  opening: 5,
  update_tunnel_floor_casing: 2,
  increase_tunnel_length: 4,
  increase_tunnel_width: 3,
};

import { IBotData } from './bot';

export interface CalculateTotalActionsOptions {
  compiled?: boolean;
}

export interface ProgressCalculator {
  completedProcesses: number;
  percentCoefficient: number;
  allProcesses: number;
  calculateCompletedPercent: (process?: number, finished?: number) => number;
  reset: () => void;
  initialize?: (
    botData: IBotData,
    options?: CalculateTotalActionsOptions,
  ) => void;
}
